// extracted by mini-css-extract-plugin
export default {"col":"ColBox_col__8rt-K","imgBox":"ColBox_imgBox__CXo42","description":"ColBox_description__XeD1+","title":"ColBox_title__UEScD"};